import { Stack } from "@mui/material";
import Space from "./Space";
import { ReactNode } from "react";
import { ColorHexCodes } from "../util/Color";

export default function PageWrapper({ children, storeGroupName }: { children: ReactNode; storeGroupName: string }) {
  return (
    <Stack sx={{ alignItems: "center", backgroundColor: `#${ColorHexCodes.HeaderBackGround}`, paddingBottom: "40px" }}>
      <Stack style={{ maxWidth: "800px", width: "100%" }}>
        <Space h={20} />
        <div style={{ fontSize: "16px", textAlign: "center" }}>{storeGroupName}</div>
        <Space h={5} />
        {children}
      </Stack>
    </Stack>
  );
}
